module.exports = __webpack_public_path__ + "img/mon_nom_est_johnny_decembre_2021.1224aae5.jpg";